export const NAV_FILES_TAB_ATTRIBUTES = {
  INITIAL_PAGE: 'data-initial-page',
  INITIAL_TYPE: 'data-initial-type',
  INITIAL_FOLDER_ID: 'data-initial-folder-id',
}
